module.exports = __webpack_public_path__ + "static/media/chuckapproved.6c95a236.png";